import { HttpHeaders } from '@angular/common/http';

/**
 * Hjálpar-klasi fyrir HTTP requestur, sérstaklega á móti internal API.
 */
export class HttpRequestHelper {
    getRequestOptionsAuth() {
        try {
            const requestOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Access-Control-Allow-Headers': 'Content-Type',
                    Authorization: 'Bearer ' + localStorage.getItem('_accessToken'),
                }),
            };
            return requestOptions;
        } catch {
            return null;
        }
    }

    getRequestOptionsAuthFileUpload() {
        try {
            const requestOptions = {
                headers: new HttpHeaders({
                    Accept: '*/*',
                    'Access-Control-Allow-Headers': 'Content-Type',
                    Authorization: 'Bearer ' + localStorage.getItem('_accessToken'),
                }),
            };
            return requestOptions;
        } catch {
            return null;
        }
    }

    getRequestOptionsAuthLibra(token: string) {
        try {
            const requestOptions = {
                headers: new HttpHeaders({
                    Accept: '*/*',
                    Authorization: 'Bearer ' + token,
                    'Access-Control-Allow-Origin': '*',
                }),
                withCredentials: true,
            };
            return requestOptions;
        } catch {
            return null;
        }
    }
}
